import { Labels, ScreenLabels } from 'common/enums'
import { dateFormat } from 'common/time'
import { UserTable } from 'common/types/table/user'
import { User } from 'common/types/user'
import { null2str } from 'common/utils'
import LeftBlue from 'components/atoms/BorderLine/LeftBlue'
import StandardTable from 'components/atoms/Table/StandardTable'
import { AuthContext } from 'providers/AuthProvider'
import React, { useContext, useMemo } from 'react'
import { useTable, useSortBy, Column } from 'react-table'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'

const TableCard: React.VFC = () => {
  const { users } = useContext(AuthContext).storeCache
  const columns: Column<UserTable>[] = useMemo(
    () => [
      {
        Header: Labels.CompanyCODE,
        accessor: 'company_code',
      },
      {
        Header: Labels.NcsUserID,
        accessor: 'ncs_user_id',
      },
      {
        Header: Labels.UserName,
        accessor: 'name',
      },
      {
        Header: Labels.ICCard,
        accessor: 'ic_card',
      },
      {
        Header: Labels.OldPermissionName,
        accessor: 'old_permission_name',
      },
      {
        Header: Labels.OldOrganization1,
        accessor: 'old_organization_1',
      },
      {
        Header: Labels.OldOrganization2,
        accessor: 'old_organization_2',
      },
      {
        Header: Labels.OldOrganization3,
        accessor: 'old_organization_3',
      },
      {
        Header: Labels.OldOrganization4,
        accessor: 'old_organization_4',
      },
      {
        Header: Labels.OldOrganization5,
        accessor: 'old_organization_5',
      },
      {
        Header: Labels.OldOrganization6,
        accessor: 'old_organization_6',
      },
      {
        Header: Labels.NewPermissionName,
        accessor: 'new_permission_name',
      },
      {
        Header: Labels.NewOrganization1,
        accessor: 'new_organization_1',
      },
      {
        Header: Labels.NewOrganization2,
        accessor: 'new_organization_2',
      },
      {
        Header: Labels.NewOrganization3,
        accessor: 'new_organization_3',
      },
      {
        Header: Labels.NewOrganization4,
        accessor: 'new_organization_4',
      },
      {
        Header: Labels.NewOrganization5,
        accessor: 'new_organization_5',
      },
      {
        Header: Labels.NewOrganization6,
        accessor: 'new_organization_6',
      },
      {
        Header: Labels.SwitchingAt,
        accessor: 'switching_at',
      },
      {
        Header: Labels.UseStartAt,
        accessor: 'use_start_at',
      },
      {
        Header: Labels.UseEndAt,
        accessor: 'use_end_at',
      },
    ],
    []
  )
  const data: UserTable[] = useMemo(
    () =>
      users.map((u: User) => {
        return {
          company_code: u.client.company_code,
          ncs_user_id: u.ncs_user_id,
          name: u.name,
          ic_card: null2str(u.ic_card),
          old_permission_name: null2str(u.old_permission_name),
          old_organization_1: null2str(u.old_organization_1),
          old_organization_2: null2str(u.old_organization_2),
          old_organization_3: null2str(u.old_organization_3),
          old_organization_4: null2str(u.old_organization_4),
          old_organization_5: null2str(u.old_organization_5),
          old_organization_6: null2str(u.old_organization_6),
          new_permission_name: null2str(u.new_permission_name),
          new_organization_1: null2str(u.new_organization_1),
          new_organization_2: null2str(u.new_organization_2),
          new_organization_3: null2str(u.new_organization_3),
          new_organization_4: null2str(u.new_organization_4),
          new_organization_5: null2str(u.new_organization_5),
          new_organization_6: null2str(u.new_organization_6),
          switching_at: dateFormat(u.switching_at),
          use_start_at: u.use_start_at ? dateFormat(u.use_start_at) : '',
          use_end_at: u.use_end_at ? dateFormat(u.use_end_at) : '',
        }
      }),
    [users]
  )
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable<UserTable>({ columns, data }, useSortBy)

  return (
    <div className="main-content">
      <Container className="mt-3">
        <Row className="justify-content-center">
          <Col lg="12" md="12">
            <LeftBlue content={ScreenLabels.User} />
            <Card className="bg-secondary shadow border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <StandardTable
                  getTableProps={getTableProps}
                  getTableBodyProps={getTableBodyProps}
                  headerGroups={headerGroups}
                  rows={rows}
                  prepareRow={prepareRow}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default TableCard
